// components/TreeDetailPDF.tsx
import React, { useRef } from "react";
import Tree from "../Tree";
import TreeInfo from "../TreeInfo";
import { Card, Row, Col } from "react-bootstrap";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { parentTreeIcon } from "@helper/marker";

type TreeDetailPDFProps = {
  tree: any;
  treeImages?: any[];
  leafImages?: any[];
};
export const TreeDetailPDF: React.FC<TreeDetailPDFProps> = ({
  tree,
  treeImages = [],
  leafImages = [],
}) => {
  const func = () => {
    console.log("Set");
  };
  const lat = parseFloat(tree?.position?.lat);
  const lng = parseFloat(tree?.position?.lng);
  return (
    <div style={{ padding: "20px", fontFamily: "Arial", width: "100%" }}>
      <h2>{tree.name}</h2>
      <Tree
        tree={tree}
        edit={false}
        setEdit={func}
        soilEdit={false}
        setSoilEdit={func}
        selectedInstallation={null}
        setSelectedInstallation={func}
        showData={false}
        setShowData={func}
      />
      <TreeInfo tree={tree} />
      {/* Map */}
      {lat && lng && (
        <div
          //   className="tree-pdf-container"
          style={{ height: "400px", width: "100%", marginBottom: "20px", marginTop: "20px" }}
        >
          <MapContainer
            center={[lat, lng]}
            zoom={16}
            scrollWheelZoom={false}
            style={{ height: "100%", width: "100%" }}
            dragging={false}
            doubleClickZoom={false}
            zoomControl={false}
            attributionControl={false}
          >
            {/* <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" opacity={0.5} /> */}
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={[lat, lng]} icon={parentTreeIcon(tree.health_state)} />
          </MapContainer>
        </div>
      )}

      {treeImages.length > 0 && (
        <>
          <h4 style={{ marginTop: "20px" }}>Tree Image</h4>
          <Card>
            <Card.Img
              variant="top"
              src={treeImages[0].tree_image}
              alt="tree"
              style={{ maxWidth: "100%", maxHeight: "300px" }}
            />
            <Card.Body>{treeImages[0].timestamp}</Card.Body>
          </Card>
        </>
      )}

      {leafImages.length > 0 && (
        <>
          <h4 style={{ marginTop: "20px" }}>Leaf Image</h4>
          <Card>
            <Card.Img
              variant="top"
              src={leafImages[0].leaf_image}
              alt="leaf"
              style={{ maxWidth: "100%", maxHeight: "300px" }}
            />
            <Card.Body>{leafImages[0].timestamp}</Card.Body>
          </Card>
        </>
      )}
    </div>
  );
};

export default TreeDetailPDF;
